import { render, staticRenderFns } from "./form-feedback.vue?vue&type=template&id=fcdacdb6&scoped=true&"
import script from "./form-feedback.vue?vue&type=script&lang=js&"
export * from "./form-feedback.vue?vue&type=script&lang=js&"
import style0 from "./form-feedback.vue?vue&type=style&index=0&id=fcdacdb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcdacdb6",
  null
  
)

export default component.exports